<template>
  <div>
    <div class="is-flex">
      <div>
        <checkbox v-model="is_search_positions_by_company">Get positions by company name</checkbox>
        <div class="is-flex is-align-items-center is-justify-content-space-between">
          <input dir="rtl" class="outlined full_width" v-model="search_term" placeholder="חפש/י משרה להוסיף">
        </div>
      </div>
      <div class="office_size_container">
        <p class="m-0">office_size</p>
        <select v-model="office_size" dir="rtl">
          <option :value="undefined"></option>
          <option v-for="option in office_size_options" :key="option.value" :value="option.value">{{ option.text }}</option>
        </select>
      </div>
      <div class="office_size_container">
        <p class="m-0">Skills exact</p>
        <select v-model="skills_exact" dir="rtl">
          <option :value="undefined"></option>
          <option v-for="option in this.dropdownFeaturedSkills" :key="option.value" :value="option.value">{{ option.text }}</option>
        </select>
      </div>
    </div>
    <div class="vertical_space"></div>
    <div class="vertical_space"></div>
    <div v-if="is_loading" class="is-flex is-align-items-center is-justify-content-center">
      <div class="loading"></div>
    </div>
    <div v-for="hot_position in filteredHotPositions" :key="hot_position.id" :class="{ display_none: is_loading }">
      <applicant-suggested-position :position="hot_position" :applicant="payload.applicant" class="hot_position">
      </applicant-suggested-position>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Checkbox from '@/components/Checkbox'
import ApplicantSuggestedPosition from '@/components/ApplicantSuggestedPosition'
export default {
  name: 'hot-positions-form',
  props: ['payload'],
  data () {
    return {
      office_size_options: [],
      office_size: undefined,
      skills_exact: undefined,
      is_search_positions_by_company: false,
      search_term: '',
      is_loading: true,
      hot_positions: []
    }
  },
  watch: {
    office_size () {
      this.init()
    },
    skills_exact () {
      this.init()
    }
  },
  computed: {
    filteredHotPositions () {
      let positions = []
      positions = this.hot_positions.filter(hot_position => hot_position.title.toLowerCase().includes(this.search_term.toLowerCase()))
      if (this.is_search_positions_by_company) {
        positions = this.hot_positions.filter(hot_position => hot_position.company.name.toLowerCase().includes(this.search_term.toLowerCase()))
      }
      return positions.sort((a, b) => {
        let a_offer_distance = a.offer_distance * 1
        let b_offer_distance = b.offer_distance * 1
        return a_offer_distance - b_offer_distance
      })
    },
    ...mapGetters('skills', ['dropdownFeaturedSkills'])
  },
  created () {
    this.init()
    this.fetchAllSkills()
  },
  methods: {
    init () {
      this.is_loading = true
      this.$network_utils.getAllPositions({
        is_hot: true,
        applicant_id: this.payload.applicant.resource_id,
        office_size: this.office_size,
        skills_exact: this.skills_exact
      }).then(response => {
        this.hot_positions = response
        this.getQuestionsFilters()
      })
    },
    getQuestionsFilters () {
      this.$network_utils.getQuestions({ designators: 'office_size', current_resource_id: 1, current_type: 'Applicant' }).then(response => {
        this.office_size_options = response[0].options.map(option => {
          return { text: option.text, value: option.id.toString() }
        })
        this.is_loading = false
      })
    },
    ...mapActions('skills', ['fetchAllSkills'])
  },
  components: {
    Checkbox,
    ApplicantSuggestedPosition
  }
}
</script>
<style scoped>
  .hot_position {
    border-bottom: 2px solid rgba(0, 0, 0, 0.2);
    padding-bottom: 13px;
    margin-bottom: 13px;
  }
  .office_size_container {
    margin-right: 15px;
  }
</style>
